import React from 'react';
import ComplianceLabel from '../compliance-label';
import RiskMatrixLabel from '../risk-matrix-label';
import { expirationMessage } from '../../utils';
import enumQuestionResponseStatus from '../../enum/enumQuestionResponseStatus';
import { 
  Element, 
  ContentContainer, 
  TitleContainer, 
  Title, 
  RightContainer, 
  StatusAndExpirationContainer, 
  ExpirationMessageBox 
} from './styles';

const Question = ({ item }) => (
  <Element id={`question-card-${item.id || 'unknown'}`}>
    <ContentContainer id={`question-content-${item.id || 'unknown'}`}>
      <TitleContainer id={`question-title-container-${item.id || 'unknown'}`}>
        <Title id={`question-title-${item.id || 'unknown'}`}>{item.question_details?.short_description}</Title>
      </TitleContainer>
      <RightContainer id={`question-right-container-${item.id || 'unknown'}`}>
        <StatusAndExpirationContainer id={`question-status-expiration-${item.id || 'unknown'}`}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <RiskMatrixLabel 
              id={item.id}
              probability={item.probability}
              impact={item.impact}
            />
            <ComplianceLabel status={item.response?.id} activeBC />
          </div>
          {item.response?.id !== enumQuestionResponseStatus.NOT_ANSWERED &&
            item.response?.id === enumQuestionResponseStatus.YES && (
              <ExpirationMessageBox id={`question-expiration-${item.id || 'unknown'}`}>
                {expirationMessage(item.expiresAt)}
              </ExpirationMessageBox>
            )}
        </StatusAndExpirationContainer>
      </RightContainer>
    </ContentContainer>
  </Element>
);

export default Question;
